import {GenericList} from './GenericList';
import {Position} from '../../models/Position';

export class PositionList extends GenericList<Position> {}
